export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7634.16f978ad.jpg";